<template>
  <el-form
    class="form form__passowrd_reset"
    ref="form"
    :model="passwordResetForm"
    :rules="rules"
    @submit.native.prevent="sendPasswordReset()"
    v-loading="!!loading"
  >

    <messages :messages="messages" :request="request" :errorMessages="errorMessages"></messages>

    <input-email-field
      id="email"
      :disabled="!isOnline"
      v-model="passwordResetForm.email"
    />

    <div class="card__footer">
      <div class="card__footer_button_wrap">
        <el-button
          type="primary"
          native-type="submit"
          :disabled="!passwordResetForm.email"
        >
          {{$t('applicationReset')}}
        </el-button>
      </div>
      <p class="card__footer_footnote">
        <router-link class="card__footer_link" :to="{ name: 'Home' }" exact>
          {{$t('applicationCancel')}}
        </router-link>
      </p>
    </div>

  </el-form>
</template>

<script>
  import InputEmailField from './inputs/InputEmailField.vue';
  import validations from './inputs/validations';
  import authentication from '@/authentication';
  import i18n from '@/configured/vue-i18n';
  import { mapActions, mapState } from 'vuex';
  import Messages from './Messages.vue';
  import offline from '@/offline';
  
  export default {
    name: 'PasswordResetForm',
    data() {
      return {
        messages: [],
        passwordResetForm: {
          email: '',
        },
        request: null,
        loading: false,
        rules: {
          email: validations.rules().email,
        },
        errorMessages: {
          pending_verification: i18n.i18n.t('authenticationPendingVerification'),
          account_locked: i18n.i18n.t('autheticationAccountLocked'),
          account_cooldown: i18n.i18n.t('autheticationAccountCooldown'),
        }
      }
    },
    computed: {
      ...mapState(offline.store.namespace, [
        'isOnline'
      ]),
    },
    methods: {
      ...mapActions(authentication.store.namespace, [
        'requestPasswordReset',
      ]),
      sendPasswordReset() {
        this.messages = [];
        this.loading = true;
        this.request = this.requestPasswordReset(this.passwordResetForm.email).
          then(this.handleSuccess);
        this.request.then(()=>{ this.loading=false }, ()=>{ this.loading=false });
      },
      handleSuccess() {
        this.messages = [];
        this.$emit('success', this.passwordResetForm.email);
      },
    },
    components: {
      InputEmailField,
      Messages
    }
  }
</script>

<style lang="scss" scoped>
  .el-button-group {
    width: 100%;

    .el-button {
      width: 50%;
    }
  }
</style>
